import { IEditorExportState } from '~src/store/editor/export/types';
import { IStudioState } from '~src/store/types';

const getExportState = (state: IStudioState): IEditorExportState => {
    return state.editor.export;
};

export { getExportState };
